<a [class]="'w-link-button ' + classList" (click)="onLinkClick()">
  <ng-content></ng-content>
</a>